import { staticSettings } from "@montana/helpers/static-settings.helper";
import { createServiceFunction } from "../http";
// eslint-disable-next-line no-undef
import LatLngBoundsLiteral = google.maps.LatLngBoundsLiteral;

export const getStores = createServiceFunction((language: string, marketId: string) => {
    const url = `${staticSettings.apiUrl}/api/stores/get-all-stores/${language}/${marketId}`;

    return f => f(url, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
});

export const getStoresInMapBounds = createServiceFunction((worldCorners: LatLngBoundsLiteral, language: string | undefined) => {
    const url = `${staticSettings.apiUrl}/api/stores/get-all-stores-geo/${language}?topLat=${worldCorners.north}&topLong=${worldCorners.east}&bottomLat=${worldCorners.south}&bottomLong=${worldCorners.west}`;

    return f => f(url, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
});

export const getStoresFromTextSearch = createServiceFunction((query: string, language: string) => {
    const url = `${staticSettings.apiUrl}/api/stores/get-all-stores-text-search/${language}?searchQuery=${query}`;

    return f => f(url, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
});
